module.exports = __webpack_public_path__ + "static/media/prodinv_myicon.9c4b2b74.ico";